import Profile from "../../../assets/photo.png";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Checkbox, Container, Grid, IconButton, Tooltip } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import PhotoUpload from "../../../assets/upload_photo.png";
import SignUpload from "../../../assets/upload_sign.png";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { Formik } from "formik";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { CanvasPreview } from "../../../components/Dashboard/UploadDocument/CanvasPreview";
import { UseDebounceEffect } from "../../../components/Dashboard/UploadDocument/UseDebounceEffect";
import "react-image-crop/dist/ReactCrop.css";
import "../../../styles/Layout/Admin_Styles/_ReUploadImageCroper.scss";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AuthContext } from "../../../context/AuthContext";
import { Buffer } from "buffer";
import UploadPhoto from "../../../assets/upload_photo.png";

Buffer.from("anything", "base64");
window.Buffer = window.Buffer || require("buffer").Buffer;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const defaultValues = {
  candidatephoto: null,
};

const aspectRatios = {
  candidateImg: {
    width: {
      max: 170,
      min: 130,
    },
    height: {
      max: 220,
      min: 180
    }
  },
  sign: {
    width: {
      max: 170,
      min: 130,
    },
    height: {
      max: 120,
      min: 80
    }
  },
}

function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 100,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}
const allowedTypes = ["image/jpg", "image/jpeg"];

const cropDefualtValue = {
  candidateImg: "",
  sign: "",
};

function ReUploadImageCroper(_props) {
  const { imageUrl, userId, handleUpdate } = _props;
  const [popupOpen, setPopupOpen] = useState(false);
  const { setIsLoading, setToastState, setAlertState } =
    useContext(AuthContext);
  const [openInfoBox, setOpenInfoBox] = useState(false);
  const formRef = useRef();
  const [docs, setDocs] = useState({});
  const [crop, setCrop] = useState(cropDefualtValue);
  const [type, setType] = useState("");
  const [open, setOpen] = React.useState(false);
  const [imgSrc, setImgSrc] = useState(cropDefualtValue);
  const [scale, setScale] = useState({
    candidateImg: 1,
    sign: 1,
  });
  const [verified, setVerified] = useState({
    candidateImg: false,
    sign: false,
  });
  const [isWarning, setIsWarning] = useState(false);
  const [reUpload, setReupload] = useState(false);
  const [aspect, setAspect] = useState(16 / 9);
  const imgRef = useRef(null);
  const signRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(cropDefualtValue);
  const previewCanvasRef = useRef(null);
  const previewSignCanvasRef = useRef(null);
  const hiddenFileInput = React.useRef(null);

  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   if (type?.length > 0) setOpen(true);
  // }, [type]);

  UseDebounceEffect(
    async () => {
      if (
        completedCrop[type]?.width &&
        completedCrop[type]?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // console.log(imgRef?.current, 'imgRef')
        // console.log(completedCrop[type], 'completedCrop')
        // We use canvasPreview as it's much faster than imgPreview.
        const file = await CanvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop[type],
          scale[type]
        );
        formRef?.current?.setFieldValue("candidatephoto", file);
      }
      // if (
      //   completedCrop[type]?.width &&
      //   completedCrop[type]?.height &&
      //   signRef.current &&
      //   previewSignCanvasRef.current
      // ) {
      //   // We use canvasPreview as it's much faster than imgPreview.
      //   const file = await CanvasPreview(
      //     signRef.current,
      //     previewSignCanvasRef.current,
      //     completedCrop[type],
      //     scale[type]
      //   );
      //   // console.log(file, 'Hii')
      //   formRef?.current?.setFieldValue("candidatesign", file);
      // }
    },
    100,
    [completedCrop, scale]
  );

  function handleToggleAspectClick() {
    if (aspect) {
      setAspect(undefined);
    } else if (imgRef.current) {
      const { width, height } = imgRef.current;
      setAspect(16 / 9);
      setCrop(centerAspectCrop(width, height, 16 / 9));
    }
  }

  const checkAspectRatio = (value) => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(value);
      reader.onload = function (value) {
        const img = new Image();
        img.src = value.target.result;
        img.onload = function () {
          const aspectRatio = this.width / this.height;
          resolve({ width: this.width, height: this.height });
        };
      };
    });
  }

  function onSelectFile(e, type) {
    // console.log(e.target.files, type)
    if (e.target.files && e.target.files.length > 0) {
      setCrop((prev) => ({ ...prev, [type]: undefined }));
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        // console.log(reader.result?.toString())
        setImgSrc((prev) => ({
          ...prev,
          [type]: reader.result?.toString() || "",
        }));
      });
      reader.readAsDataURL(e.target.files[0]);
      setOpen(true);
    }
  }

  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop((prev) => ({
        ...prev,
        [type]: centerAspectCrop(width, height, aspect),
      }));
    }
  }

  const UploadSchema = Yup.object().shape({
    candidatephoto: Yup.mixed()
      .required("Photo is required")
      .test(
        "FILE_FORMAT",
        "Only support JPG/JPEG",
        (value) => !value || (value && allowedTypes.includes(value.type))
      )
      .test(
        'fileAspectRatio',
        'Only support dimensions 150W x 200H px',
        value => value && ((aspectRatios?.candidateImg?.width?.min <= value?.aspectRatio?.width && aspectRatios?.candidateImg?.width?.max >= value?.aspectRatio?.width) && (aspectRatios?.candidateImg?.height?.min <= value?.aspectRatio?.height && aspectRatios?.candidateImg?.height?.max >= value?.aspectRatio?.height))
      ),
    // .test(
    //   "fileSize",
    //   "Photograph should not be less than 20 KB and more than 50 KB",
    //   (value) =>
    //     !value || (value && value.size < 1024 * 50 && value.size > 1024 * 20)
    // ),
  });

  const submitHandler = async (data) => {
    setIsLoading(true);
    const tempData = { ...data };
    // console.log("data :>> ", data);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    authHttp
      .post(
        apisPath?.admin?.uploadImage,
        { ...tempData, user_id: userId },
        config
      )
      .then((res) => {
        setToastState((prev) => ({ ...prev, open: true, msg: res?.data?.msg }));
        setCompletedCrop(cropDefualtValue);
        setCrop(cropDefualtValue);
        setImgSrc(cropDefualtValue);
        setPopupOpen(false);
        handleUpdate();
        formRef?.current?.setFieldValue("candidatephoto", "");
        hiddenFileInput.current.value = "";
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const verifyImage = (type) => {
    setIsLoading(true);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const tempData = {
      type: type === "candidateImg" ? "photo" : "sign",
      image:
        type === "candidateImg"
          ? formRef?.current?.values?.candidatephoto
          : formRef?.current?.values?.candidatesign,
    };

    authHttp
      .post(apisPath?.front?.user?.verifyImage, { ...tempData }, config)
      .then((res) => {
        setToastState((prev) => ({ ...prev, open: true, msg: res?.data?.msg }));
        // resetForm();
        // setIsWarning(true)
        setVerified((prev) => ({
          ...prev,
          [type]: true,
        }));
        handleClose();
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        handleClose();
        setVerified((prev) => ({
          ...prev,
          [type]: false,
        }));
        setCompletedCrop((prev) => ({
          ...prev,
          [type]: "",
        }));
        setImgSrc((prev) => ({
          ...prev,
          [type]: "",
        }))
        if (type === "candidateImg") {
          formRef?.current?.setFieldValue("candidatephoto", "");
          hiddenFileInput.current.value = "";
        }
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
        }));
      });
  };

  const handlePopupFunction = () => {
    setOpenInfoBox(!openInfoBox);
  };
  const handleImageClick = () => {
    setPopupOpen(true);
  };
  const handlePopupClose = () => {
    formRef?.current?.setFieldValue("candidatephoto", "");
    hiddenFileInput.current.value = "";
    setImgSrc((prev) => ({
      ...prev,
      candidateImg: "",
    }))
    setPopupOpen(false);
  };

  const selectImageHandler = () => {
    hiddenFileInput.current.click();
  };

  return (
    <Formik
      initialValues={defaultValues}
      validationSchema={UploadSchema}
      onSubmit={submitHandler}
      innerRef={formRef}
    >
      {({
        handleChange,
        values,
        handleSubmit,
        setFieldValue,
        errors,
        touched,
        handleBlur,
        setFieldTouched,
        isValid,
        isSubmitting,
        dirty,
      }) => (
        <>
          <div onClick={handleImageClick}>
            {imageUrl ? (
              <img src={imageUrl} alt="Profile" />
            ) : (
              <AccountCircleRoundedIcon
                sx={{ fontSize: "46px", cursor: "pointer" }}
              />
            )}
          </div>
          <Dialog open={popupOpen}>
            <div className="reUpload-image--popup">
              <div className="reUpload-image--popup__info">
                <h3>Re-Upload Image</h3>
                <span>
                  <Tooltip title="Close" onClick={handlePopupClose}>
                    <IconButton>
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </span>
              </div>
              <div
                className="reUpload-image--popup-box"
                onClick={selectImageHandler}
              >
                {!imgSrc['candidateImg'] ? (
                  <>
                    <img src={UploadPhoto} alt="PhotoUpload" />
                    <span className="choose">Choose File</span>
                    <span className="notChoose">No File Chosen</span>
                  </>
                ) : (
                  <img
                    // ref={previewCanvasRef}
                      src={imgSrc['candidateImg']}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "275px",
                    }}
                  />
                )}
              </div>
              {imgSrc['candidateImg'] && (
                <div className="reUpload-image--popup--submit">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleSubmit}
                  >
                    Save changes
                  </Button>
                </div>
              )}
            </div>
          </Dialog>

          <input
            className="chooseImg"
            accept="image/jpg,image/jpeg"
            onChange={async (e) => {
              setType("candidateImg");
              if (allowedTypes.includes(e.target.files[0].type)) {
                onSelectFile(e, "candidateImg");
              }
              Object.defineProperty(e.target.files[0], 'aspectRatio', {
                value: await checkAspectRatio(e.target.files[0])
              });
              setFieldValue("candidatephoto", e.target.files[0]);
              // handleBlur(e)
            }}
            name="candidatephoto"
            type="file"
            ref={hiddenFileInput}
            onBlur={(e) => {
              setFieldValue("isSubmit", "");
              handleBlur(e);
            }}
            onClick={(e) => {
              handleBlur(e);
            }}
            style={{ display: "none" }}
          />

          <BootstrapDialog
            // onClose={handleClose}
            className="upload-document--modal"
            aria-labelledby="customized-dialog-title"
            open={open}
          >
            <DialogContent dividers>
              {/* <div className="scaleDiv">
                <label htmlFor="scale-input">Scale: </label>
                <input
                  id="scale-input"
                  type="number"
                  step="0.1"
                  min={"0.1"}
                  value={scale[type]}
                  // disabled={!imgSrc}
                  onChange={(e) =>
                    setScale((prev) => ({
                      ...prev,
                      [type]: Number(e.target.value),
                    }))
                  }
                />
              </div> */}

              {/* <div style={{ display: "none" }}>
                <button onClick={handleToggleAspectClick}>
                  Toggle aspect {aspect ? "on" : "off"}
                </button>
              </div> */}
              {
                // <ReactCrop
                //   crop={crop[type]}
                //   onChange={(_, percentCrop) =>
                //     setCrop((prev) => ({ ...prev, [type]: percentCrop }))
                //   }
                //   onComplete={(c) =>
                //     setCompletedCrop((prev) => ({ ...prev, [type]: c }))
                //   }
                //   aspect={!aspect}
                // >
                <img
                  className="upload-document--img"
                  ref={type === "candidateImg" ? imgRef : signRef}
                  alt="Crop me"
                  src={imgSrc[type]}
                // style={{ transform: `scale(${scale[type]})` }}
                // onLoad={onImageLoad}
                />
                // </ReactCrop>
              }
            </DialogContent>
            <DialogActions
              className={
                ((errors.candidatephoto && touched.candidatephoto) ||
                  (errors.candidatesign && touched.candidatesign)) &&
                "upload-document--eSecDiv"
              }
            >
              {/* {errors.candidatephoto}
              {JSON.stringify(touched.candidatephoto)} */}
              <div className="upload-document--eSec">
                <div className="imgErrors">
                  {type === "candidateImg"
                    ? (errors.candidatephoto &&
                      touched.candidatephoto) && (
                      <p className="text-danger">{errors.candidatephoto}
                      </p>
                    )
                    : errors.candidatesign &&
                    touched.candidatesign && (
                      <p className="text-danger">{errors.candidatesign}</p>
                    )}
                </div>
                <div className="upload-document--btns1">
                  <div className="upload-document--btn1">
                    <Button
                      autoFocus
                      onClick={() => {
                        // verifyImage(type);
                        setVerified((prev) => ({
                          ...prev,
                          [type]: false,
                        }));
                        setCompletedCrop((prev) => ({
                          ...prev,
                          [type]: "",
                        }));
                        setImgSrc((prev) => ({
                          ...prev,
                          [type]: "",
                        }))
                        if (type === "candidateImg") {
                          formRef?.current?.setFieldValue("candidatephoto", "");
                          hiddenFileInput.current.value = "";
                        }
                        handleClose()
                      }}
                    >
                      Close
                    </Button>
                  </div>
                  <div className="upload-document--btn2">
                    <Button
                      autoFocus
                      variant="contained"
                      disabled={type === 'candidateImg' ? (errors.candidatephoto && touched.candidatephoto) : (errors.candidatesign && touched.candidatesign)}
                      onClick={() => {
                        verifyImage(type);
                        // handleClose()
                      }}
                    >
                      Verify
                    </Button>
                  </div>
                </div>
              </div>
            </DialogActions>
          </BootstrapDialog>
        </>
      )}
    </Formik>
  );
}

export default ReUploadImageCroper;
